export const preventDefault = (e: React.SyntheticEvent<any>) => e.preventDefault();
